import React from 'react';
import { Drawer, Button, Panel, Divider, Tag, Stack } from 'rsuite';
import { Icon } from '@rsuite/icons';
import { MdPerson } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
const DetailsDrawer = ({ open, onClose, data }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'ACTIVE':
        return 'green';
      case 'PENDING':
        return 'yellow';
      case 'REFUSED':
        return 'red';
      default:
        return 'grey';
    }
  };

  const getStatusText = (status: string | undefined) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return t('Booked');
      case 'ended':
        return t('Checked-In');
      case 'closed':
        return t('Checked-out');
      case 'canceled':
        return t('Canceled');
      default:
        return 'Unknown';
    }
  };
  const { t } = useTranslation();
  return (
    <Drawer
      backdrop="static"
      size="sm"
      placement="right"
      open={open}
      onClose={onClose}
    >
      <Drawer.Header>
        <Drawer.Title>{t('Request Details')}</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={onClose} appearance="primary">
           {t('Close')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Panel bordered style={{ padding: '16px', borderRadius: '8px' }}>
          <Stack spacing={10}>
            <Icon as={MdPerson} style={{ fontSize: '25px', color: '#3498ff' }} />
            <h5 style={{ margin: 0, color: '#333' }}>
              {`${data?.user?.firstname || ''} ${data?.user?.lastname || ''}`}
            </h5>
          </Stack>

          <Divider />

          <div style={{ padding: '0 10px', lineHeight: 1.8 }}>
            {[
              {
                label:t( 'Status'),
                value: (
                  <Tag color={getStatusColor(data?.status)}>
                    {t(getStatusText(data?.status))}
                  </Tag>
                )
              },
              {
                label: t('Desk'),
                value: data?.desk?.name || 'N/A'
              },
              {
                label: 'Zone',
                value: data?.desk?.zone?.name || 'N/A'
              },
              {
                label: t('Floor'),
                value: data?.desk?.zone?.floor?.name || 'N/A'
              },
              {
                label: t('Reservation Date'),
                value: new Date(data?.reservationdate).toLocaleDateString() || 'N/A'
              },
              {
                label: t('Time Slot'),
                value: data?.timeslot || 'N/A'
              },
              {
                label: t('Manager'),
                value: `${data?.manager?.firstname || ''} ${data?.manager?.lastname || 'N/A'}`
              },
              {
                label: t('Comments'),
                value: data?.comments || 'N/A'
              }
            ].map((item, index) => (
              <div key={index} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
                <strong>{item.label}:</strong>
                <span>{item.value}</span>
              </div>
            ))}
          </div>
        </Panel>
      </Drawer.Body>
    </Drawer>
  );
};

export default DetailsDrawer;
